export const RECIPE_CULINARY_REFERENCES = Object.freeze([
  Object.freeze({
    id: "ssn-balanced-plate",
    label: "Société Suisse de Nutrition · recettes de l’assiette équilibrée",
    url: "https://www.sge-ssn.ch/fr/recommandations/recommandations-officielles/recettes/",
    principle: "des recettes lisibles, structurées et adaptées à un repas du quotidien",
  }),
  Object.freeze({
    id: "swissmilk-seasonal-recipes",
    label: "Swissmilk · recettes locales et de saison",
    url: "https://www.swissmilk.ch/fr/recettes-idees/",
    principle: "une cuisine simple à reproduire, locale, saisonnière et attentive au gaspillage",
  }),
]);

export function buildRecipeCulinaryReferencePrompt() {
  const references = RECIPE_CULINARY_REFERENCES
    .map((reference) => `- ${reference.label} (${reference.url}) : ${reference.principle}.`)
    .join("\n");

  return `----- QUALITE CULINAIRE ET REFERENCES -----

Les references ci-dessous sont des REPERES DE QUALITE, jamais une autorisation
de copier une recette et jamais une regle qui remplace le plan ou les
directives d'Anissa :
${references}

Tu n'as pas acces a ces pages pendant cet appel. N'affirme jamais avoir lu,
teste ou adapte une recette precise de ces sites. N'invente jamais une URL,
un auteur, une marque, une origine ou une citation. Les recettes rendues sont
des propositions originales construites depuis les repas et contraintes
fournis. Le plan, les exclusions et les directives d'Anissa ont toujours
priorite sur ces reperes generaux.

Chaque recette doit etre realisable dans une cuisine courante : ordre des
etapes coherent, quantites et temps plausibles, temperature ou repere de
cuisson quand necessaire, materiel courant, aucune etape implicite essentielle.`;
}
